import { environment } from '../../environments/environment';

export const BE_API_URL = environment.apiUrl;
export const BE_API_AUTH_URL = environment.apiAuthUrl;
export const DOMAIN = environment.domain;
export const SESSION_REVOKED_NOTICE_KEY = 'sessionRevokedNotice';
export const PASSWORD_CHANGED_NOTICE_KEY = 'passwordChangedNotice';
export const MFA_REQUIRED_NOTICE_KEY = 'mfaRequiredNotice';
export const ADMIN_MFA_ACCESS_NOTICE_KEY = 'adminMfaAccessNotice';

const globalWindow: any = typeof window !== 'undefined' ? window : {};
export const WEB_PUSH_PUBLIC_KEY = globalWindow.__env?.WEB_PUSH_PUBLIC_KEY || '';
export const TRANSLATION_ENABLED = !DOMAIN.includes('localhost');
const ADDRESS_NAME_PART = `[\\p{L}\\s.'-]+`;
export const ADDRESS_PATTERN = new RegExp(
  `^((?:${ADDRESS_NAME_PART})\\s+(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?)` +
    `(?:\\s*[\\/+]\\s*(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?))*` +
    `(?:\\s*\\/\\s*(?:${ADDRESS_NAME_PART})\\s+(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?)` +
    `(?:\\s*[\\/+]\\s*(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?))*)*` +
    `(?:\\s*,\\s*(?:${ADDRESS_NAME_PART})\\s+(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?)` +
    `(?:\\s*[\\/+]\\s*(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?))*` +
    `(?:\\s*\\/\\s*(?:${ADDRESS_NAME_PART})\\s+(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?)` +
    `(?:\\s*[\\/+]\\s*(?:\\d{1,4}[A-Za-z]?(?:\\s*-\\s*(?:\\d{1,4}[A-Za-z]?|[A-Za-z]))?))*)*)*)` +
    `\\s*,\\s*(?=.*[\\p{L}])(\\d{5}(?:\\s+[\\p{L}\\s'-]+)?(?:\\s*[/,+]\\s*\\d{5}(?:\\s+[\\p{L}\\s'-]+)?)*)$`,
  'u'
);
